module.exports = __webpack_public_path__ + "img/monitor_nodata.d3c64c7d.png";